import React, { Component } from 'react';
import isEqual from 'lodash/isEqual';

const APP_ID = "egfebvv7";

/**
 * Empty component used to encapsulate Intercom chat behaviour.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
export default class IntercomChat extends Component {
  constructor(props) {
    super(props);

    this.updateIntercom = this.updateIntercom.bind(this);
    this.boot = this.boot.bind(this);
  }

  runCommand(command, args) {
    if (!window.Intercom) {
      console.log('Intercom command:', command, args);
    } else {
      window.Intercom(command, args);
    }
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps, this.props)) {
      this.updateIntercom(prevProps, this.props);
    }
  }

  boot() {
    const { user } = this.props;

    if (!window.intercomBooted) {
      const args = {
        app_id: APP_ID,
        custom_launcher_selector: "#custom_intercom_launcher"
      };

      if (user.id) {
        args.email = user.email;
        args.id = user.id;
      }

      this.runCommand('boot', args);
      window.intercomBooted = true;
    }
  }

  /* make sure changes in props are reflected */
  updateIntercom(prevProps={}, currentProps={}) {

    /* remove previously added `bodyClasses` */
    if (prevProps.bodyClasses) {
      prevProps.bodyClasses.split(' ').forEach(cls => document.body.classList.remove(cls));
    }

    if (currentProps.shouldShow) {
      /* only run commands to show if not showing already */
      if (!prevProps.shouldShow) {
        this.boot();

        document.body.classList.add("with-intercom");

        if (currentProps.chatOnly) {
          document.body.classList.add("with-intercom-as-chat-only");
        }

        if (currentProps.expandOnShow) {
          this.runCommand('show');
        }
      }

      /* add `bodyClasses` to body if provided */
      if (currentProps.bodyClasses) {
        currentProps.bodyClasses.split(' ').forEach(cls => document.body.classList.add(cls));
      }
    } else {
      document.body.classList.remove("with-intercom", "with-intercom-as-chat-only");
    }
  }

  componentDidMount() {
    this.updateIntercom(undefined, this.props);
  }

  componentWillUnmount() {
    this.updateIntercom(this.props);
  }

  render() {
    return (
      <div id="custom_intercom_launcher">
        <i className="fa fa-question"/>
        <h4>Help</h4>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./common/components/intercom_chat.jsx